import { Component, OnInit, Inject } from '@angular/core';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { PostSurgicalClinicService } from 'src/app/Services/NewORNote/postSurgical.service';

@Component({
  selector: 'app-display-staff-list',
  templateUrl: './display-staff-list.component.html',
  styleUrls: ['./display-staff-list.component.css']
})
export class DisplayStaffListComponent implements OnInit {

  public staff: IUserDetails[] = [];
  public selectedStaff: IUserDetails[] = [];
  public staffType: string;
  staffFrom: IUserDetails[] = [];
  staffTo: IUserDetails[] = [];
  staffRoles: string[] = [];
  displayStaffListForm: FormGroup;
  public result: string;
  public AssistantName: string = ""
  constructor(public dialogRef: MatDialogRef<DisplayStaffListComponent>, private postSurgicalService: PostSurgicalClinicService,
    @Inject(MAT_DIALOG_DATA) public passedData: any, private sharedService: SharedService,
    private fb: FormBuilder) {

    this.staff = passedData.staff;
    this.selectedStaff = passedData.selectedStaff;
    this.staffType = passedData.staffType;
    this.staffRoles = passedData.roles;
    if (passedData.staffType == "StartedBy") {
      this.AssistantName = "Select/Deselect Started By Names [Location Specific 'Nurse' & 'Provider' Role Users]"
    } else if (passedData.staffType == "Radiographer") {
      this.AssistantName = "Select/Deselect Radiographer Names [Location Specific 'Nurse' & 'Provider' Role Users]"
    } else if (passedData.staffType == "Anesthesiologist") {
      this.AssistantName = "Select/Deselect Anesthesiologist Names [Location Specific 'Nurse' & 'Provider' Role Users]"
    } else if (passedData.staffType == "Anaesthetist") {
      this.AssistantName = "Select/Deselect Anesthetist Names [Location Specific 'Nurse' & 'Provider' Role Users]"
    }
    else {
      this.AssistantName = "Select/Deselect Assistant Names [Location Specific 'Nurse' & 'Clerk' Role Users]"
    }
  }

  ngOnInit() {
    this.displayStaffListForm = this.fb.group({
      from: [''],
      to: ['']
    });
  }
  onCancelClick(): void {
    this.dialogRef.close(this.staffType);
  }
  public ngOnDestroy() {
    this.onCancelClick();
  }
  moveToNextList() {
    this.postSurgicalService.addStaffDetails(this.staffFrom, this.staffType).subscribe(data => {
      this.result = data;
      this.sharedService.getUsersbyMultipleRoles(this.staffRoles[0], this.staffRoles[1], null, this.staffType).subscribe(data => {
        this.staff = [];
        this.selectedStaff = [];
        this.staff = data.filter(user => user.status === 'False');
        if (this.staff != undefined) {
          this.staff = this.staff.filter(
            // (thing, i, arr) => arr.findIndex(t => t.fullName.toLowerCase() === thing.fullName.toLowerCase()) === i
            (thing, i, arr) => arr.findIndex(t => t.userId.toLowerCase() === thing.userId.toLowerCase()) === i
          );
        }
        this.selectedStaff = data.filter(user => (user.status === 'True' && user.staffType === this.staffType));
        if (this.selectedStaff != undefined) {
          return this.selectedStaff = this.selectedStaff.filter(
            // (thing, i, arr) => arr.findIndex(t => t.fullName.toLowerCase() === thing.fullName.toLowerCase()) === i
            (thing, i, arr) => arr.findIndex(t => t.userId.toLowerCase() === thing.userId.toLowerCase()) === i
          );
        }
      })
      this.staffFrom = [];
    })
  }

  moveToPrevList() {
    this.postSurgicalService.deleteStaffDetails(this.staffTo, this.staffType).subscribe(data => {
      this.result = data;
      this.sharedService.getUsersbyMultipleRoles(this.staffRoles[0], this.staffRoles[1], null, this.staffType).subscribe(data => {
        this.staff = [];
        this.selectedStaff = [];
        this.staff = data.filter(user => user.status === 'False' && user.staffType != this.staffType);
        if (this.staff != undefined) {
          this.staff = this.staff.filter(
            // (thing, i, arr) => arr.findIndex(t => t.fullName.toLowerCase() === thing.fullName.toLowerCase()) === i
            (thing, i, arr) => arr.findIndex(t => t.userId.toLowerCase() === thing.userId.toLowerCase()) === i
          );
        }

        this.selectedStaff = data.filter(user => (user.status === 'True' && user.staffType == this.staffType));
        if (this.selectedStaff != undefined) {
          return this.selectedStaff = this.selectedStaff.filter(
            // (thing, i, arr) => arr.findIndex(t => t.fullName.toLowerCase() === thing.fullName.toLowerCase()) === i
            (thing, i, arr) => arr.findIndex(t => t.userId.toLowerCase() === thing.userId.toLowerCase()) === i
          );
        }
      })
      this.staffTo = [];
    })
  }


  onUserClicked(index: number, item: IUserDetails, event) {
    if (event.currentTarget.ariaSelected === "false") {
      if (this.staffFrom.length === 0) {
        this.staffFrom.push(item);
      }
      else if (!this.staffFrom.find(x => x.userId === item.userId)) {
        this.staffFrom.push(item);
      }
    }
    else {
      const index0 = this.staffFrom.indexOf(item, 0);
      if (index0 > -1) {
        this.staffFrom.splice(index0, 1);
      }
    }
  }
  userClicked(index: number, item: IUserDetails, event) {
    if (event.currentTarget.ariaSelected === "false") {
      if (this.staffTo.length === 0) {
        this.staffTo.push(item);
      }
      else if (!this.staffTo.find(x => x.userId === item.userId)) {
        this.staffTo.push(item);
      }
    }
    else {
      const index1 = this.staffTo.indexOf(item, 0);
      if (index1 > -1) {
        this.staffTo.splice(index1, 1);
      }
    }
  }

}
